import { render } from "./VaultsList.vue?vue&type=template&id=39cbbe9c&scoped=true&ts=true"
import script from "./VaultsList.vue?vue&type=script&lang=ts"
export * from "./VaultsList.vue?vue&type=script&lang=ts"

import "./VaultsList.vue?vue&type=style&index=0&id=39cbbe9c&scoped=true&lang=css"
import "./VaultsList.vue?vue&type=style&index=1&id=39cbbe9c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cbbe9c"]])

export default __exports__